module.exports = __webpack_public_path__ + "img/Penny-Tote-04.f5f3715e.jpg";